




















import DropdownList from "@share/common/drop-down/DropdownList.vue";
import { DropDownItem } from "@share/common/drop-down/types";
import { Component, Prop } from "vue-property-decorator";
import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";

@Component({
    components: { DropdownList }
})

export default class TextSelect extends BaseBorderless {

    @Prop({ default: [] }) declare value: string;
    @Prop({ default: (() => [])}) source: DropDownItem[];

    @Prop() dropdownClass: string | undefined;

    showDropdown = false;

    open() {
        this.showDropdown = true;
    }

    toggle() {
        this.showDropdown = !this.showDropdown;

        this.showDropdown && this.getInput()?.focus();
    }

    getInput() {
        return this.$el.getElementsByTagName('input').item(0);
    }

    select(value: DropDownItem) {
        this.model = value.title;
        this.$emit('select', value);
        this.closeDropdown();
    }

    closeDropdown() {
        this.showDropdown = false;
    }
}

